import React from "react";
import { Box, Typography } from "@mui/material";

const CapsuleProgress = ({ progress, text, isVip = false, themeColors }) => {
  return (
    <Box
      sx={{
        height: 32,
        width: "65%",
        background: "transparent",
        borderRadius: 20,
        position: "relative",
        border: "1px solid",
        borderColor: "grey.500",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: `${Math.min(Math.max(progress, 0), 100)}%`,
          background: "#FBC02D",
          borderRadius: 20,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: 4,
          top: "50%",
          transform: "translateY(-50%)",
          width: 12,
          height: 12,
          borderRadius: "50%",
          background: "#E91E63",
        }}
      />
      <Typography
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          fontWeight: 700,
          fontSize: 13,
          px: 1,
          color: themeColors?.text || "#000",
        }}
      >
        {text}
        {!isVip && (
          <Box component="span" sx={{ fontWeight: 800, color: "#FBC02D" }}>
            VIP
          </Box>
        )}
      </Typography>
    </Box>
  );
};

export default CapsuleProgress;
